/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const AngleRight = ({ color = '#717782', ...props }: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      {...props}
      data-palette="AngleRight">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L18 0 18 18 0 18z"
                  transform="translate(-990 -539) translate(722 217) translate(183 316) translate(85 6)"
                />
                <path
                  fill={color}
                  fillRule="nonzero"
                  d="M9.879 9L6.167 5.287 7.227 4.227 12 9 7.227 13.773 6.167 12.713z"
                  transform="translate(-990 -539) translate(722 217) translate(183 316) translate(85 6)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default AngleRight;
